/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');

import Vue from 'vue'
window.Vue = Vue;
import SettingComponent from "./components/SettingComponent.vue";
import AlertComponent from "./components/AlertComponent.vue";

Vue.component(
    'setting-component',
    SettingComponent
);
Vue.component(
    'alert-component',
    AlertComponent
);

import videojs from 'video.js';
import hlsQualitySelector from '@pm-connect/videojs-hls-quality-selector';
import qualityLevels from 'videojs-contrib-quality-levels';
import 'videojs-mux';
videojs.registerPlugin('qualityLevels', qualityLevels);
videojs.registerPlugin('hlsQualitySelector', hlsQualitySelector);

import Slideout from 'slideout';
import axios from 'axios';

require('@silvermine/videojs-chromecast')(videojs, { preloadWebComponents: true });

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if (document.getElementById('app')) {
    const app = new Vue({
        el: '#app'
    });
}

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
        .then(function(reg) {
            // successfully registered
        })
        .catch(function(err) {});
}

window.playingPlayer = null;

try {
    require.ensure(['jquery'], function(jquery) {
        window.$ = window.jQuery = jquery;
        $(document).ready(function() {
            $('#languageSwitcher').on('change', function (e) {
                $(this).closest('form').trigger('submit');
            });

            initVideos(document.getElementsByClassName('video-js'));

            const videoList = $('#video-list');
            if (videoList.length) {
                videoList[0].addEventListener('app.scroll-load.after', function (e) {
                    e.detail.elements.forEach(elem => initVideos(elem.getElementsByClassName('video-js')));
                });
            }

            if (typeof freeBrowsing !== 'undefined' && !freeBrowsing) {
                // Change users video quality settings when event emitted
                window.addEventListener('videoQualityChanged', function (e) {
                    const userLevel = e.detail;
                    axios.post(qualitySettingsRoute, {setting: videoQualitySettingKey, value: userLevel.toString()});
                });
            }

            if ($('main').length) {
                // -------------------------------------------------------- HEADER CHANGES ON SCROLL
                let didScroll;
                let lastScrollTop = 0;
                const delta = 5;
                const navbarHeight = $('header.main').outerHeight();
                $(window).scroll(function(){
                    didScroll = true;
                });
                setInterval(function() {
                    if (didScroll) {
                        hasScrolled();
                        didScroll = false;
                    }
                }, 250);
                function hasScrolled() {
                    const st = $(this).scrollTop();
                    if (Math.abs(lastScrollTop - st) <= delta)
                        return;
                    if (st > lastScrollTop && st > navbarHeight){
                        $('header.main').removeClass('nav-down').addClass('nav-up');
                    } else {
                        if (st + $(window).height() < $(document).height()) {
                            $('header.main').removeClass('nav-up').addClass('nav-down');
                        }
                    }
                    lastScrollTop = st;
                }

                // -------------------------------------------------------- SLIDE OUT MENU
                if (document.getElementById('menu')) {
                    const slideout = new Slideout({
                        'panel': document.getElementById('panel'),
                        'menu': document.getElementById('menu'),
                        'padding': 275,
                        'tolerance': 70,
                        'touch': false
                    });
                    // Toggle button
                    $('.toggle').click(function () {
                        slideout.toggle();
                        return false;
                    });
                    slideout.on('beforeopen', function () {
                        $('.fixed').addClass('fixed-open');
                    });
                    slideout.on('beforeclose', function () {
                        $('.fixed').removeClass('fixed-open');
                    });
                }
            }

            // -------------------------------------------------------- CLOSE ALERT
            $('.alert a').click(function(){
                $(this).closest('.alert').hide();
                return false;
            });

            // --------------------------------------------- TRIGGERS FOR MIX PANEL TRACKING
            $(window).on('load', function(){
                const autoplayVideo = $('video[autoplay]');

                if (autoplayVideo.length > 0) {
                    autoplayVideo.click();
                }

                $('video').on('play', function () {
                    $(this).data('action_type', 'VideoPlayed');
                    $(this).click();
                });

                $('video').on('pause', function () {
                    $(this).data('action_type', 'VideoPaused');
                    $(this).click();
                });

                $('video').on('seeked', function () {
                    $(this).data('action_type', 'VideoSearched');
                    $(this).click();
                });

                $('video').on('volumechange', function () {
                    $(this).data('action_type', 'VideoVolumeChange');
                    $(this).click();
                });

                $('video').on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function () {
                    $(this).data('action_type', 'VideoFullScreen');
                    $(this).click();
                });
            });
        });
    });
} catch (e) {}

function initVideos(elements) {
    for (let i = elements.length - 1; i >= 0; i--) {
        initVideoPlayer(elements[i]);
    }
}

function initVideoPlayer(elem) {
    const player = videojs(elem, {
        techOrder: ['chromecast', 'html5' ], // You may have more Tech, such as Flash or HLS
        controls: true,
        playsinline: true,
        html5: {
            hls: {overrideNative: true},
            NativeAudioTracks: false,
            NativeVideoTracks: false,
        },
        aspectRatio: '16:9',
        fluid: true,
        plugins: {
            'chromecast': {},
            mux: {
                debug: false,
                data: {
                    env_key: window.MUX_ENV_KEY, // required
                    // Metadata
                    player_init_time: Date.now(), // ex: 1451606400000
                    video_title: elem.getAttribute('data-action_data')
                }
            },
            qualityLevels: {},
            hlsQualitySelector: {
                title: videoQualityTranslation
            }
        }
    });
    player.on('playing', function () {
        if (window.playingPlayer !== null && window.playingPlayer !== this && typeof window.playingPlayer.pause === 'function') {
            window.playingPlayer.pause();
        }
        window.playingPlayer = this;
    });

    // Fix for Android ¯\_(ツ)_/¯
    if (player.currentSrc().indexOf('.m3u8') !== -1) {
        player.src(player.currentSrc());
    }

    player.ready(function () {
        const player = this;
        this.qualityLevels().one('change', function () {
            player.hlsQualitySelector._qualityButton.items.forEach(item => {
                if (defaultVideoResolution !== videoResolutionAuto) {
                    defaultVideoResolution = parseInt(defaultVideoResolution, 10);
                }
                if (item.item.value === defaultVideoResolution) {
                    item.trigger('click');
                }
            });
        });
    })
}

import Notifications from "./notifications";
import Favourites from "./favourites";
window.Notifications = new Notifications();
window.Favourites = Favourites;
